import {TextLinkWidget} from '@tableau/widgets';
import React from 'react';

import {
  openReactActionDialog,
  ReactActionDialogBodyProps,
  ReactActionDialogOptions
} from '~commonInfra/dialogs/ReactActionDialog';
import {TabDialogWidth} from '~commonInfra/dialogs/style/TabDialogWidth';
import {HelpService} from '~commonInfra/services/HelpService';
import {CommonStyles} from '~commonInfra/styles/CommonStyles';
import {Messages} from '~src/codegen/Localize';
import {
  KMS_IN_ONLINE_ENABLEMENT_INFO_LINK
} from '~src/settings/general-settings/components/sections/kms-in-online/KMSInOnlineSection';
import {learnMoreStyle} from '~src/settings/styles/CommonStyles';

function KeyDeletionBodyComponent(props: ReactActionDialogBodyProps<{}, string>) {
  return <span>
      {Messages.extractEncryptionTOLKeyDeletionDialog()}
      <TextLinkWidget
        testId={KMS_IN_ONLINE_ENABLEMENT_INFO_LINK}
        href={HelpService.getServerHelpUrlByCategory('customer-managed-encryption-keys')}
        target="_blank"
        rel="noopener noreferrer"
        className={learnMoreStyle}
      >
        {Messages.learnMore()}
      </TextLinkWidget>
      <div style={{marginTop: CommonStyles.Sizes.LargeSpace, marginBottom: CommonStyles.Sizes.SmallSpace}}>
        {Messages.extractEncryptionTOLKeyDeletionInstructions()}
      </div>
      <div style={{display:'block', textAlign: 'center', marginBottom: CommonStyles.Sizes.LargeSpace}}>
        {Messages.extractEncryptionTOLKeyDeletionDialogConfirmation()}
        <input value={props.dialogState} onChange={e => props.updateDialogState(e.target.value)} type={'text'}
               style={{display: 'block', position: 'relative', margin: '0 auto', width: '50%'}}/>
      </div>
  </span>;
}

/**
 * Generate dialog to ask user to confirm whether to delete extract encryption key
 */
export function KeyDeletionConfirmationDialog(): Promise<void> {

  let keyDeletionOptions: ReactActionDialogOptions<any, any, any> = {
    dismissDialogOnActionFailed: true,
    initialBodyProps: undefined,
    initialDialogState: '',
    title: Messages.extractEncryptionTOLKeyDeletionDialogPrompt(),
    bodyComponent: KeyDeletionBodyComponent,
    actionName: Messages.extractEncryptionTOLKeyDeletionDialogConfirmation(),
    action: () => {return Promise.resolve();},
    isActionDelete: true,
    dialogWidth: TabDialogWidth.width500px,
    showCloseButton: true,
    actionDisabled: (_, dialogState) => {return dialogState !== 'Delete Key';},
  };

  return openReactActionDialog(keyDeletionOptions).result;
}